module.exports = __webpack_public_path__ + "static/img/gm_benefit03.36cf4419.png";